import { PHONE_QUERY, useMediaQuery } from "@/hooks/use-media-query"

/** Sidebar's phone check - the same scaled breakpoint as the rest of the
 *  app, so the sidebar turns into a drawer exactly where MobileHeader and
 *  MobileBottomNav take over. */
export function useIsMobile() {
  return useMediaQuery(PHONE_QUERY)
}
